/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
    // 倒计时
    function getRandomNum(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
    }

    let endTimeG;

    function cutDownTime() {
        let nowTime = new Date();
        let endTime = new Date(endTimeG);

        let leftTime = endTime.getTime() - nowTime.getTime();
        if (leftTime < 0) {
            setupNewCountdown();
            leftTime = 0;
        }
        let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
            leftM = Math.floor((leftTime / (1000 * 60)) % 60),
            leftS = Math.floor((leftTime / 1000) % 60);
        leftH = leftH >= 10 ? leftH : "0" + leftH;
        leftM = leftM >= 10 ? leftM : "0" + leftM;
        leftS = leftS >= 10 ? leftS : "0" + leftS;

        return {
            hour: leftH,
            minute: leftM,
            second: leftS,
        };
    }
    function setupNewCountdown() {
        const randomHour = getRandomNum(1, 9);
        const currentTime = new Date();
        endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
    }
    let intervalId;

    function getCutDownTime() {
        setupNewCountdown();
        if (intervalId) clearInterval(intervalId);
        intervalId = setInterval(function () {
            let cutDownTimeText = cutDownTime();
            $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
            $(".sp_top_cut_down .sp_left_view .sp_minute").html(
                cutDownTimeText.minute
            );
            $(".sp_top_cut_down .sp_left_view .sp_second").html(
                cutDownTimeText.second
            );
        }, 1000);
    }

    getCutDownTime();

    let spImgList = [
        "https://cdn.shopify.com/s/files/1/0819/9156/5621/files/spp_shopify20251229100520_641519cc2681dc4555c8d04a7d923815_4f7b31ac-a065-4341-8369-d5d34bf6068e.jpg?v=1787038953",
        "https://cdn.shopify.com/s/files/1/0819/9156/5621/files/spp_shopify20251229100520_e16d6bc5684c47a558c681d7e0ddcce9_ad4708ef-0e52-40e1-8987-bfd46339d096.jpg?v=1787038901",
        "https://cdn.shopify.com/s/files/1/0819/9156/5621/files/2_615f3048-32e1-466c-a133-6c742dad1822.jpg?v=1787039281",
        "https://cdn.shopify.com/s/files/1/0819/9156/5621/files/1_1ad761a6-218a-49cc-a2f3-9fe17661b183.jpg?v=1787039280",
        "https://cdn.shopify.com/s/files/1/0819/9156/5621/files/202510152-b3.png",
        "https://cdn.shopify.com/s/files/1/0819/9156/5621/files/202510152-b4.png",
        "https://cdn.shopify.com/s/files/1/0819/9156/5621/files/202510152-b5.png",
        "https://cdn.shopify.com/s/files/1/0819/9156/5621/files/202510152-b6.png",
        "https://cdn.shopify.com/s/files/1/0819/9156/5621/files/202510152-b7.png",
    ];

    new Swiper(".sp-swiper3", {
        autoplay: true,
        autoplay: {
            disableOnInteraction: false,
            delay: 1,
        },
        speed: 4200,
        spaceBetween: 9,
        slidesPerView: "auto",
        loop: true,
    });

    function mainRender() {
        $(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);

            window.addEventListener(
                "resize",
                (function () {
                    var timer;
                    return function () {
                        if (timer) clearTimeout(timer);
                        timer = setTimeout(function () {
                            $("#root").css("zoom", "normal");
                            let scale = document.body.clientWidth / 1080;
                            $("#root").css("zoom", scale);
                        }, 100);
                    };
                })()
            );
        });

        function lazyLoadImages() {
            // 懒加载
            const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
            const config = {
                rootMargin: "0px 0px 1300px 0px",
                threshold: 0,
            };

            const lazyLoadObserver = new IntersectionObserver(function (
                entries,
                observer
            ) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        // 当图片进入视口时
                        const image = entry.target;
                        const dataSrc = image.getAttribute("data-src");
                        image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
                        lazyLoadObserver.unobserve(image); // 停止观察该图片
                    }
                });
            },
                config);

            images.forEach(function (image) {
                lazyLoadObserver.observe(image); // 开始观察每个图片
            });
        }

        function preloadImages(imageArray) {
            // 预加载
            // 检查数组数据结构
            if (Array.isArray(imageArray[0])) {
                // 处理二维数组
                imageArray.forEach((subArray) => {
                    subArray.forEach((url) => {
                        const img = new Image();
                        img.src = url;
                    });
                });
            } else {
                // 处理一维数组
                imageArray.forEach((url) => {
                    const img = new Image();
                    img.src = url;
                });
            }
        }

        lazyLoadImages();

        preloadImages(spImgList);

        // 找到所有跳转套餐的锚点链接
        var links = document.querySelectorAll('a[href^="#shopping"]');
        links.forEach(function (link) {
            link.addEventListener("click", function (event) {
                event.preventDefault(); // 阻止默认的跳转行为
                // var targetElement = document.getElementById('shopping');
                // if (targetElement) {
                //     targetElement.scrollIntoView({ behavior: 'smooth' });
                // } // 方式一
                const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
                const offsetTop = targetElement.offsetTop;
                let _topHeight =
                    $(".time-part").height() +
                    $(".sp-header-top").height() +
                    $(".sp-nav").height();
                window.scroll({
                    top:
                        offsetTop * $("div#root").css("zoom") -
                        _topHeight * $("div#root").css("zoom"),
                    behavior: "smooth", // 使用 smooth 实现平滑滚动
                }); // 方式二
            });
        });

        // 找到所有跳转套餐的锚点链接
        var links = document.querySelectorAll('a[href^="#add-cart"]');
        links.forEach(function (link) {
            link.addEventListener("click", function (event) {
                event.preventDefault(); // 阻止默认的跳转行为
                // var targetElement = document.getElementById('shopping');
                // if (targetElement) {
                //     targetElement.scrollIntoView({ behavior: 'smooth' });
                // } // 方式一
                const targetElement = document.getElementById("add-cart"); // 获取跳转目标节点
                const offsetTop = targetElement.offsetTop;
                let _topHeight =
                    $(".time-part").height() +
                    $(".sp-header-top").height()
                window.scroll({
                    top:
                        offsetTop * $("div#root").css("zoom") -
                        _topHeight * $("div#root").css("zoom"),
                    behavior: "smooth", // 使用 smooth 实现平滑滚动
                }); // 方式二
            });
        });

        // IOS字体多了间距的处理 给节点添加 sp_system 类名
        // 判断当前用户是安卓端还是iOS端
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        var isAndroid = /android/i.test(userAgent);
        var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
        var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

        if (isAndroid) {
            console.log("Android");
        } else if (isIOS) {
            console.log("iOS");
        } else if (isPC) {
            console.log("PC");
        } else {
            $(".sp_system").css("letter-spacing", "-4px");
        }
    }

    mainRender();

    let sp_price1 = 16.98;
    let sp_price2 = 35.96;

    function calcTotal(price, num) {
        let result = Number(price) * Number(num);
        return result.toFixed(2);
    }

    // let prods = window.product
    // function getCur() {
    //     let color = $('#sp-opt-group1 div.active').attr('data-val')
    //     let size = $('#sp-opt-group2 div.active').attr('data-val')

    //     return prods.filter(
    //         item => item.option1 == color && item.option2 == size
    //     )[0]
    // }
    // function changePrice() {
    //     let num = $('#calcNumber').val()
    //     let price = ((getCur().price * num) / 100).toFixed(2)
    //     let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
    //     // if(num == 1){
    //     //   price = (getCur().price * num / 100).toFixed(2)
    //     // }else if(num == 2){
    //     //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
    //     // }else if(num == 3){
    //     //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
    //     // }else {
    //     //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
    //     // }
    //     price = (price + '').replace('.', ',')
    //     compare = (compare + '').replace('.', ',')
    //     $('#sp_price1').html(price)
    //     $('#sp_price2').html(compare)
    //     let off_font =
    //         100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
    //     $('.product-part .sp-row p span').html(off_font)
    // }
    const $priceDom = $('#sp_price1');
    const $cPriceDom = $('#sp_price2');
    const $offPriceDom = $('.font-off');
    const $numDom = $('#calcNumber');

    const productData = window.product || [];

    /** 获取当前选中的变量 */
    function getCur() {
        const opts = {
            option1: $('#sp-opt-group1 div.active').attr('data-val'),
            option2: $('#sp-opt-group2 div.active').attr('data-val'),
            option3: $('#sp-opt-group3 div.active').attr('data-val')
        };

        return productData.find(item => {
            return (!opts.option1 || item.option1 == opts.option1) &&
                (!opts.option2 || item.option2 == opts.option2) &&
                (!opts.option3 || item.option3 == opts.option3);
        });
    }

    /** 更新价格显示 */
    function changePrice() {
        const curVariant = getCur();
        if (!curVariant) return;

        const num = parseInt($numDom.val()) || 1;

        // 识别当前页面使用的小数点符号
        const currentText = $priceDom.text().trim();
        const decimalMatch = currentText.match(/([\.,])(\d+)(?!.*[\.,])/);

        const decimalSeparator = decimalMatch ? decimalMatch[1] : '.';
        const decimalLength = decimalMatch ? decimalMatch[2].length : 0;

        // 格式化输出
        const formatValue = (cents) => {
            let val = (cents * num / 100).toFixed(decimalLength);
            if (decimalSeparator === ',') {
                val = val.replace('.', ',');
            }
            return val;
        };

        const price = formatValue(curVariant.price);
        const compare = formatValue(curVariant.compare_at_price);

        // 计算折扣
        let offPercent = 0;
        if (curVariant.compare_at_price > curVariant.price) {
            offPercent = 100 - Math.ceil((curVariant.price / curVariant.compare_at_price) * 100);
        }

        const priceRegex = /\d+(?:[.,]\d+)*/;
        const offRegex = /(\d+)(?=(?:<[^>]+>|\s)*%)/g;

        const updateHTML = ($el, regex, value) => {
            if ($el && $el.length) {
                const text = $el[0].textContent.trim();
                const newHtml = text.replace(regex, value);
                if ($el.html() !== newHtml) {
                    $el.html(newHtml);
                }
            }
        };

        updateHTML($priceDom, priceRegex, price);
        updateHTML($cPriceDom, priceRegex, compare);
        updateHTML($offPriceDom, offRegex, offPercent);
    }
    $('.sp-btn-style').click(function () {
        let num = $('#calcNumber').val()
        window.location.href = '/cart/' + getCur().id + ':' + num
    })

    $(".sp-reduce").click(function () {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) - 1;
        if (num > 0) {
            input.value = num;
        }
        changePrice()
    });
    $(".sp-add").click(function () {
        let input = $(this).siblings("input")[0];
        let num = Number(input.value) + 1;
        input.value = num;
        changePrice()
    });

    $(".sp-option").click(function () {
        $(this).siblings().removeClass("active");
        $(this).addClass("active");


        let opt1 = $("#sp-opt-group1 .sp-option.active").index();
        // let opt2 = $("#sp-opt-group2 .sp-option.active").index();
        let opt2 = 0;

        const imgIndex = opt1 + opt2 * 2
        $(".product-part .sp-img-p")[0].src = spImgList[imgIndex];


        // $(".sp-name").html($("#sp-opt-group1 .sp-option.active").text());
        // if(opt1==5){
        //   $(".product-part .sp-img-p")[0].src = spImgList[1];
        // }else{
        // $(".product-part .sp-img-p")[0].src = spImgList[0];
        // }

        changePrice()
    });

    $(function () {
        // 购物车加购动效
        $(".cart-btn").click(function () {
            $(this).children("img").addClass("on");
            $(".sp-header-top .sp-cart .num").show();
            setTimeout(function () {
                $(".cart-btn").children("img").removeClass("on");
            }, 500);
            $(".sp-header-top .sp-cart").addClass("on");
            setTimeout(function () {
                $(".sp-header-top .sp-cart").removeClass("on");
            }, 500);
        });

        let initNum = 0;
        $(".product-part .cart-btn").click(function () {
            //   let spNum = $(".product-part #calcNumber")[0].value;
            //   initNum += Number(spNum);

            //   // $("#calcNumber").val(1);
            //   $("#cardNum").html(initNum);
            var data = {
                id: getCur().id,
                quantity: $('#calcNumber').val(),
            }
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: data,
                success: function () {
                    $.getJSON(
                        window.Shopify.routes.root + 'cart.js',
                        function (result) {
                            $('#cardNum').html(result.item_count)
                            $("#cardNum").removeClass("sp-gray");
                        }
                    )
                },
                dataType: 'json',
            })

            // handleAddToCart(initNum);

            var img = $(".product-part .sp-img-p");
            // var img = $(".product-part .sp-swiper .swiper-slide-active .sp-img");

            var flyer = img[0].cloneNode(true);
            flyer.classList.add("sp_clone");

            $(".product-part").append(flyer);
            $(".sp_clone").css({
                width: img[0].width,
                height: img[0].height,
                background: "#e7e9ef",
                position: "fixed",
                top: img[0].offsetTop,
                left: img.offset().left,
                "z-index": "99",
            });

            let finish = $(".sp-cart");
            $(".sp_clone").animate(
                {
                    // top: finish[0].offsetTop,
                    top: finish[0].offsetTop,
                    left: finish[0].offsetLeft + finish.width() / 2,
                    width: 50, // 结束时的大小，根据需要调整
                    height: 50, // 结束时的大小，根据需要调整
                    opacity: 0.4,
                },
                500,
                "linear",
                function () {
                    $(this).animate(
                        {
                            width: 0,
                            height: 0,
                            opacity: 0,
                        },
                        0,
                        function () {
                            $(this).detach();
                        }
                    );
                }
            );
        });
    });

    // 标题文本渐出
    const graduallyList = document.getElementsByClassName("gradually");
    for (let gradually of graduallyList) {
        const spans = gradually.querySelectorAll("span");
        const paragraph = gradually.querySelector(".sp-sub-title");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // 给每个 span 和 i 动画
                        spans.forEach((span, index) => {
                            span.style.animation = `swift-up-fade 0.5s ease forwards`;
                            span.style.animationDelay = `${index * 0.1}s`;

                            const i = span.querySelector("i");
                            if (i) {
                                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                                i.style.animationDelay = `${index * 0.1}s`;
                            }
                        });

                        // 段落
                        const totalDelay = spans.length * 0.1 + 0.3;
                        if (paragraph) {
                            paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
                            paragraph.style.animationDelay = `${totalDelay}s`;
                        }

                        observer.unobserve(gradually);
                    }
                });
            },
            {
                threshold: 0.3,
            }
        );
        observer.observe(gradually);
    }
});
